import * as RHF from 'react-hook-form';

export const useFormValidation = RHF.useForm;
